var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("breadcrumbs-bar", { attrs: { breadcrumbs: _vm.breadcrumbs } }),
      _c("div", { staticClass: "page-help" }, [
        _c("div", { staticClass: "page-help__title" }, [
          _c("h1", [_vm._v(_vm._s(_vm.helpItemTitle))])
        ]),
        _c("div", { staticClass: "page-help__body" }, [
          _c("div", { staticClass: "page-help__desc" }, [
            _c("div", {
              staticClass: "box-desc",
              domProps: { innerHTML: _vm._s(_vm.helpItemContent) }
            })
          ])
        ]),
        _c("div", { staticClass: "page-help__bottom" }, [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c("h2", [
                _vm._v(_vm._s(_vm.$t("front.help.titles.need_more_help")))
              ]),
              _c(
                "v-btn",
                {
                  on: {
                    click: function($event) {
                      _vm.supportDialog = true
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("front.help.button.contact_us")))]
              )
            ],
            1
          )
        ])
      ]),
      _c(
        "v-dialog",
        {
          attrs: {
            "content-class": "dialog-support",
            "max-width": "900px",
            persistent: _vm.isDialogPersistent
          },
          model: {
            value: _vm.supportDialog,
            callback: function($$v) {
              _vm.supportDialog = $$v
            },
            expression: "supportDialog"
          }
        },
        [
          _vm.supportDialog
            ? _c("support-popup", {
                on: {
                  close: function($event) {
                    _vm.supportDialog = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }